import $ from "jquery"

window.$ = $
window.jQuery = $

import initSelect2 from "select2"

initSelect2(window, $)

import toastr from "toastr/build/toastr.min.js"

window.toastr = toastr
import "toastr/build/toastr.min.css"

window.toastr.options = {
  closeButton: true,
  progressBar: true,
  timeOut: 3000,
  positionClass: "toast-top-right"
}
export default $
